import { Component } from '@angular/core';
import { PageComponent } from '@tytapp/common';

@Component({
    selector: 'tyt-live-schedule-page',
    template: `
        <tyt-full-live-schedule />
        <div class="sidebar">
            <tyt-plus-ad-block />
            <tyt-mobile-ad-block />
            <tyt-newsletter-module />
        </div>
    `,
    styles: `
        :host {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            gap: 1em;
        }

        .sidebar {
            max-width: 400px;
        }

        tyt-full-live-schedule {
            flex-grow: 1;
        }

        @media (max-width: 900px) {
            :host {
                flex-direction: column;
                .sidebar {
                    max-width: initial;
                }
            }
        }
    `
})
export class LiveSchedulePageComponent extends PageComponent {
    init() {
        this.pageTitle = 'Live Schedule';
    }
}
